import { Consts, ReduxUtils } from '../../dependencies';

const { EXPENSE_TRIGGERS } = Consts.entityKeys;
const { FETCH } = Consts.apiTypes;

export const expenseTriggersApiSelector = state => ReduxUtils.paginationApiSelector(state, EXPENSE_TRIGGERS, FETCH);
